export default class ServiceAnfordernRequest {
  id: string
  kommentare: string
  rechnungAnfordern: boolean = false
  bestellungId: string
}
